<template>
  <div class="flight-item clearfix">
    <div class="flight-info flex-hb-vc">
      <div :class="['airline-logo', 'logo', `logo-${itinerary.airlineCode?.toLocaleLowerCase()}`]"></div>
      <div class="flight-time clearfix">
        <div class="dep-info">
          <p>{{ itinerary.arrivalTime | getTime }}</p>
          <p class="city">{{ itinerary.departureName }}</p>
        </div>
        <div class="route">
          <p>{{ itinerary.flightNo }}</p>
          <div class="line"></div>
          <p>{{ itinerary.departureDate }}</p>
        </div>
        <div class="dest-info">
          <p>{{ itinerary.departureTime | getTime }}</p>
          <p class="city">{{ itinerary.arrivalName }}</p>
        </div>
      </div>
      <div class="cabin">
        <p>{{ itinerary.cabinCode }}</p>
        <p>
          <span>舱位</span>
        </p>
      </div>
      <div class="seat">
        <p>{{ seatNumber }}</p>
        <p>
          <span>预选座位</span>
        </p>
      </div>
       <div class="price" v-if="seatItem?.isPaySeat">
        <p>{{ seatItem?.currency === 'CNY' ? '￥' : ''}} {{ seatItem?.price ?? 0 }} </p>
        <p>
          <span>价格</span>
        </p>
      </div>
    </div>
    <div class="passneger-info">
      <p class="name">{{ passenger.fullName }}</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get } from 'lodash'

export default {
  props: {
    passengerData: { type: Object },
    seatItem: [Object, null]
  },
  data () {
    return { }
  },
  computed: {
    itinerary () {
      return this.passengerData.itinerary || {}
    },
    passenger () {
      return this.passengerData.passenger || {}
    },
    seatNumber () {
      const { passenger, seatItem } = this
      if (seatItem === null) {
        return get(passenger, 'select.seat[0].seatNumber') || '未选择'
      } else {
        return get(seatItem, 'seatNumber') || '选座中'
      }
    }
  },
  filters: {
    getTime (value) {
      return moment(value).format('HH:mm')
    }
  }
}
</script>

<style lang="less" scoped>
.flight-item {
  padding: 10px 0;
  border: 1px solid #bfbfbf;
  .flight-info {
    float: left;
    width: 80%;
    height: 90px;
    padding: 10px;
    border-right: 1px dashed #d0d0d0;
    .logo {
      float: left;
      width: 10%;
      height: 59px;
      margin-top: 5px;
    }
    .flight-time {
      float: left;
      width: 50%;
    }
    .dep-info,
    .dest-info {
      float: left;
      width: 25%;
      margin-top: 5px;
      text-align: center;
      font-weight: bold;
      p {
        font-size: 24px;
        line-height: 32px;
        color: #000;
      }
      p.city {
        font-weight: normal;
        font-size: 14px;
      }
    }
    .route {
      float: left;
      width: 30%;
      font-size: 12px;
      line-height: 36px;
      text-align: center;
      color: #808080;
      .line {
        border-bottom: 1px solid #d0d0d0;
      }
    }
    .cabin,
    .seat,
    .price {
      float: left;
      width: 10%;
      margin-top: 10px;
      text-align: center;
      font-size: 18px;
      line-height: 26px;
      color: #000;
      font-weight: bold;
      span {
        font-weight: normal;
        font-size: 12px;
        color: #808080;
      }
    }
  }
  .passneger-info {
    float: left;
    width: 20%;
    height: 90px;
    text-align: center;
    p {
      font-size: 14px;
      line-height: 90px;
      color: #808080;
    }
    p.name {
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }
  }
}
@media only screen and (max-width: 768px) {
  .flight-item {
    border: 0;
    width: 100%;
    .logo {
      display: none;
    }
    .flight-info {
      width: 100%;
      padding: 10px 5px;
      border-right: 0;
      .flight-time {
        width: 300px;
      }
      .route {
        width: 100px;
        margin: 0 10px;
      }
      .cabin {
        margin-left: 20px;
        margin-right: 30px;
      }
    }
    .passneger-info {
      width: 100%;
      padding-top: 0;
      padding-left: 15px;
      p.name {
        display: block;
      }
      p {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
